// AUTO-GENERATED by scripts/gen-stories.js — do not edit.
// Regenerated from public/stories/*.md on start/build.
const STORIES = ["community","dont-die-little-thing","metaverse"];

export default STORIES;
